import * as React from 'react';
import { Checkbox, Input } from 'antd';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import { get } from 'lodash';
import intl from 'react-intl-universal';

import { Config, Option } from '@src/apps/interview-questionnaire/services/model';

import './index.less';

export interface MutipleSelectItemProps {
  value?: [CheckboxValueType, string][];
  onChange?: (value?: [CheckboxValueType, string][]) => void;
  config: Config;
  id?: string;
  desc?: string;
  isChild?: boolean;
  errorMsg?: string;
  resetError?: () => void;
}

const { Group } = Checkbox;
const { useRef, useMemo, useState } = React;
const MutipleSelectItem: React.FC<MutipleSelectItemProps> = ({
  value,
  onChange,
  config,
  id,
  desc,
  isChild,
  errorMsg,
  resetError,
  ...props
}) => {
  const [flag, setFlag] = useState<boolean>(true);
  const resetValue = useMemo(() => {
    // 隐藏二级标题又显示时，清空选项值
    if (isChild && flag) {
      setFlag(false);
      return [];
    }
    return value;
  }, [value]);
  const { checkedValues, specificReasons } = useMemo(() => {
    return (resetValue ?? []).reduce<{
      checkedValues: CheckboxValueType[];
      specificReasons: { [key: string]: string };
    }>(
      (res, [checked, specificReason]) => {
        res.checkedValues.push(checked);
        res.specificReasons[checked as string] = specificReason;
        return res;
      },
      {
        checkedValues: [],
        specificReasons: {}
      }
    );
  }, [resetValue]);
  const specificRreasonsRef = useRef<{ [key: string]: string }>({});
  const { options, requireReasonkeys, inputPlaceholders } = useMemo(
    () =>
      get(config, 'options', []).reduce<{
        options: { label: string; value: string }[];
        inputPlaceholders: { [key: string]: string };
        requireReasonkeys: string[];
      }>(
        // @ts-ignore
        (res, item) => {
          if (item.require_reason) {
            res.requireReasonkeys.push(get(item, 'key'));
            res.inputPlaceholders[get(item, 'key')] = get(item, 'reason_desc.i18n_name');
          }
          res.options.push({
            label: get(item, 'name.i18n_name', ''),
            value: get(item, 'key')
          });
          return res;
        },
        {
          options: [],
          inputPlaceholders: {},
          requireReasonkeys: []
        }
      ),
    [config]
  );
  const handleChange = (e: CheckboxValueType[]) => {
    resetError && resetError();
    // @ts-ignore
    onChange &&
      onChange(e.map((value) => [value, get(specificRreasonsRef.current, value as string, '')]));
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    resetError && resetError();
    const val = e.target.value;
    const ref = specificRreasonsRef.current;
    specificRreasonsRef.current = { ...ref, [id]: val };
    onChange &&
      onChange(
        (value ?? []).map(([checkedId, specificReason]) => {
          if (checkedId === id) {
            return [checkedId, val];
          }
          return [checkedId, specificReason];
        })
      );
  };
  // 修复线上评分修改值没清空问题
  React.useEffect(() => {
    return () => {
      onChange?.(undefined);
    };
  }, []);

  return (
    <div className="mobile-questionnaire__form__mutiple-select-wrapper" id={id}>
      {desc && <div className="desc">{desc}</div>}
      <Group value={checkedValues} onChange={handleChange} {...props}>
        {options.map(({ label, value }) => (
          <div key={value}>
            <p>
              <Checkbox value={value}>{label}</Checkbox>
            </p>
            <p>
              {checkedValues.includes(value) && requireReasonkeys.includes(value) && (
                <>
                  <Input.TextArea
                    className="questionnaire__form__muti_select__input--mobile"
                    placeholder={get(inputPlaceholders, value, '')}
                    value={specificReasons[value]}
                    onChange={(e) => {
                      handleInputChange(e, value);
                    }}
                    error={!!(errorMsg && !specificReasons[value])}
                    style={errorMsg && !specificReasons[value] ? { borderColor: '#ff4d4f' } : undefined}
                  />
                  {errorMsg && !specificReasons[value] && (
                    <div className="error-msg">
                      {intl.get('pleaseSupplementExplanation')}
                    </div>
                  )}
                </>
              )}
            </p>
          </div>
        ))}
      </Group>
    </div>
  );
};

export default MutipleSelectItem;
